import {createAction} from '@reduxjs/toolkit'

const sliceName = 'requestApi'

const dataSourceRequest = createAction(`${sliceName}/dataSource`)
const simpleReq = createAction(`${sliceName}/simpleReq`)

export {dataSourceRequest, simpleReq}
